<template>
  <div>
    <el-table :data="dataList">
      <el-table-column prop="id" label="#" />
      <el-table-column prop="user_id" label="用户id" />
      <el-table-column prop="pay_channel" label="支付渠道" />
      <el-table-column prop="amount" label="金额" :formatter="function(_1, _2, v) { return '' + v / 100 + '元' }"/>
      <el-table-column prop="status" label="状态" :formatter="function(_1, _2, v) { return v == 100 ? '已支付' : '未支付'}"/>
      <el-table-column prop="time" label="时间" />
    </el-table>
    <pager
      api="user_get_account_list"
      :filter="filter"
      :sort="sort"
      @data-changed="onDataChanged"
    />
  </div>
</template>

<script>
import Pager from '../ui/Pager'

export default {
  components: {
    Pager
  },
  data() {
    return {
      dataList: [],
      filter: { status: [ 100 ] },
      sort: [ {field: 'id', reverse: true} ]
    }
  },
  methods: {
    onDataChanged(dataList) {
      this.dataList = dataList
    }
  }
}
</script>